import { Link } from "react-router-dom";

import { useSession } from "@/auth/session";
import { PageHead } from "@/components/PageHead";

export function HomePage() {
  const { me } = useSession();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const name = me?.login_id.split("@")[0] ?? "";

  return (
    <div className="mpage on">
      <PageHead eyebrow="Orbit" title={`${greeting}, ${name}.`} />
      <div className="panel panel-pad">
        <div style={{ fontSize: 13, color: "var(--t-mute)" }}>
          {/* cross_company, NOT a missing name: a company whose name Orbit has
              not recorded yet is a real company and still gets named by slug. */}
          {me?.cross_company
            ? <>Signed in as <b style={{ color: "var(--t-bright)" }}>{me?.role}</b>{" "} - not tied to a company, with access to every company's data.</>
            : <>Signed in to <b style={{ color: "var(--t-bright)" }}>{me?.company_name ?? me?.company_id}</b>{" "}as {me?.role}.</>}
          {" "}Modules you can open are in the rail - the rest show SOON until they're wired.
        </div>
        {/* The raw gate ids used to be printed here"100, 200, 300 …". They
            are Orbit's own capability constants and they still ENFORCE every
            route (require_cap), but as a list of bare integers on a home page
            they told nobody anything: the rail above already names the modules
            you can open, and /plans names what you may DO, with labels and
            your plan. Two better answers to the same question made this one
            noise. */}
        <div style={{ fontSize: 12, color: "var(--t-dim)", marginTop: 10 }}>
          What each role and plan may do: <Link to="/plans">the capability matrix</Link>.
        </div>
      </div>
    </div>
  );
}
